import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSource} from "../form/application_form_source";

interface IGetShouldRequestHomeMatchBasicPreferencesParams {
    source: ApplicationSource;
    isAuthenticated: boolean;
    application?: IApplicationData | null;
}

const scheduleMeetingSources = [ApplicationSource.ApplicationOfferScheduleMeeting, ApplicationSource.ApplicationPropertyScheduleMeeting];

export const getShouldRequestHomeMatchBasicPreferences = (params: IGetShouldRequestHomeMatchBasicPreferencesParams): boolean => {
    const {source, isAuthenticated, application} = params;
    const isScheduleMeetingLead = scheduleMeetingSources.includes(source);
    const isHomeMatchAvailableForLeadType = !isScheduleMeetingLead || isAuthenticated;
    const hasUserContext = isAuthenticated || Boolean(application?.user_created);

    return isHomeMatchAvailableForLeadType && hasUserContext;
};
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSource} from "../form/application_form_source";

interface IGetShouldRequestHomeMatchBasicPreferencesParams {
    source: ApplicationSource;
    isAuthenticated: boolean;
    application?: IApplicationData | null;
}

const scheduleMeetingSources = [ApplicationSource.ApplicationOfferScheduleMeeting, ApplicationSource.ApplicationPropertyScheduleMeeting];

export const getShouldRequestHomeMatchBasicPreferences = (params: IGetShouldRequestHomeMatchBasicPreferencesParams): boolean => {
    const {source, isAuthenticated, application} = params;
    const isScheduleMeetingLead = scheduleMeetingSources.includes(source);
    const isHomeMatchAvailableForLeadType = !isScheduleMeetingLead || isAuthenticated;
    const hasUserContext = isAuthenticated || Boolean(application?.user_created);

    return isHomeMatchAvailableForLeadType && hasUserContext;
};
